import { useCallback, useEffect, useState } from "react";
import FastMarquee from "react-fast-marquee";
import { TriangleAlert } from "lucide-react";
import { api } from "@/lib/api";

export default function WarningBanner({ onChange }) {
  const [ems, setEms] = useState([]);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/incidents");
      const list = (r.data.warnings || []).filter((w) => w.bucket === "responding");
      setEms(list);
      onChange?.(list.length);
    } catch (e) {}
  }, [onChange]);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  if (!ems.length) return null;

  return (
    <div
      data-testid="emergency-warning-banner"
      className="fixed left-0 right-0 top-0 z-[60] flex h-9 items-center bg-[#FF3B30]"
    >
      <span className="flex h-full shrink-0 items-center gap-2 bg-black/25 px-3 font-jb text-[10px] font-bold tracking-[0.2em] text-black">
        <TriangleAlert className="h-3.5 w-3.5" />
        EMERGENCY WARNING
      </span>
      <FastMarquee speed={30} gradient={false}>
        {ems.map((w) => (
          <span
            key={w.id}
            className="px-10 font-jb text-[10px] font-bold tracking-[0.2em] text-black"
          >
            {String(w.title || "").toUpperCase()}
            {w.location ? ` — ${String(w.location).toUpperCase()}` : ""} · CHECK
            VICEMERGENCY.GOV.AU
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
